<app-page-layout>
    <page-heading>
        <app-page-heading>
            <heading>Mijn profiel</heading>
            <description>Beheer je persoonlijke gegevens en accountinstellingen.</description>
        </app-page-heading>
    </page-heading>
    <page-body>
        @if (userProfile(); as profile) {
            <div class="space-y-8">
                <!-- Profile Header -->
                <div class="bg-white shadow-sm rounded-lg border border-gray-200">
                    <div class="px-6 py-8">
                        <div class="flex items-center gap-x-6">
                            @if (profile.picture) {
                                <img
                                    class="h-24 w-24 rounded-full object-cover"
                                    [src]="profile.picture"
                                    alt="Profielfoto"
                                />
                            } @else {
                                <app-avatar
                                    size="large"
                                    [employee]="{
                                        firstName: profile.firstName,
                                        lastName: profile.lastName
                                    }"
                                />
                            }
                            <div>
                                <h2 class="text-2xl font-semibold text-gray-900">
                                    {{ profile.firstName }} {{ profile.lastName }}
                                </h2>
                                <p class="text-sm text-gray-500 mt-1">
                                    {{ profile.email }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Personal Information -->
                <div class="bg-white shadow-sm rounded-lg border border-gray-200">
                    <div class="px-6 py-5 border-b border-gray-200">
                        <h3 class="text-lg font-medium text-gray-900">
                            Persoonlijke informatie
                        </h3>
                    </div>
                    <div class="px-6 py-5">
                        <dl class="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2">
                            <div>
                                <dt class="text-sm font-medium text-gray-500">Voornaam</dt>
                                <dd class="mt-1 text-sm text-gray-900">{{ profile.firstName || '-' }}</dd>
                            </div>
                            <div>
                                <dt class="text-sm font-medium text-gray-500">Achternaam</dt>
                                <dd class="mt-1 text-sm text-gray-900">{{ profile.lastName || '-' }}</dd>
                            </div>
                            <div class="sm:col-span-2">
                                <dt class="text-sm font-medium text-gray-500">E-mailadres</dt>
                                <dd class="mt-1 text-sm text-gray-900">{{ profile.email }}</dd>
                            </div>
                        </dl>
                    </div>
                </div>

                <!-- Account Actions -->
                <div class="bg-white shadow-sm rounded-lg border border-gray-200">
                    <div class="px-6 py-5 border-b border-gray-200">
                        <h3 class="text-lg font-medium text-gray-900">
                            Account acties
                        </h3>
                    </div>
                    <div class="px-6 py-5">
                        <button
                            type="button"
                            (click)="logout()"
                            class="inline-flex items-center gap-x-2 rounded-md bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                        >
                            <svg class="-ml-0.5 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M3 4.25A2.25 2.25 0 015.25 2h5.5A2.25 2.25 0 0113 4.25v2a.75.75 0 01-1.5 0v-2a.75.75 0 00-.75-.75h-5.5a.75.75 0 00-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-2a.75.75 0 011.5 0v2A2.25 2.25 0 0110.75 18h-5.5A2.25 2.25 0 013 15.75V4.25z" clip-rule="evenodd"/>
                                <path fill-rule="evenodd" d="M19 10a.75.75 0 00-.75-.75H8.704l1.048-.943a.75.75 0 10-1.004-1.114l-2.5 2.25a.75.75 0 000 1.114l2.5 2.25a.75.75 0 101.004-1.114l-1.048-.943h9.546A.75.75 0 0019 10z" clip-rule="evenodd"/>
                            </svg>
                            Uitloggen
                        </button>
                    </div>
                </div>
            </div>
        }
    </page-body>
</app-page-layout>
